// routes/_app.payment.subscription.landing.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_app.payment.subscription.landing')

export const handle = {
  name: 'payment/subscription/landing',
  hideMembershipBanner: true,
  showCreditPill: true,
}

export default dynamic(getClientModule, { ssr: false })
